@if (mode$ | async; as mode) {
  <button
    type="button"
    dir="ltr"
    class="
      btn
      border-0
      rounded-pill
      d-inline-flex
      align-items-center
      flex-shrink-0
      p-1
    "
    [ngClass]="{
      'bg-gray-300': mode === 'dark',
      'bg-body-secondary shadow-sm': mode === 'light'
    }"
    [attr.aria-label]="
      mode === 'dark'
        ? 'Activate light mode'
        : 'Activate dark mode'
    "
    [attr.aria-pressed]="mode === 'dark'"
    (click)="toggle()">

    <span
      class="
        position-relative
        d-inline-flex
        flex-shrink-0
        p-3
        px-5
      "
      [ngClass]="{
        'order-1': mode === 'dark',
        'order-2': mode === 'light'
      }"
      aria-hidden="true">

      <i
        class="
          position-absolute
          top-50
          start-50
          translate-middle
          text-body-secondary
          lh-1
        "
        [ngClass]="{
          'icon-sw-dark fs-5': mode === 'dark',
          'icon-sw-light fs-3': mode === 'light'
        }">
      </i>
    </span>

    <span
      class="
        d-inline-flex
        flex-shrink-0
        rounded-circle
        p-3
      "
      [ngClass]="{
        'order-2 bg-black': mode === 'dark',
        'order-1 bg-white border border-primary-subtle shadow-sm':
          mode === 'light'
      }"
      aria-hidden="true">
    </span>
  </button>
}
